<template>
  <div class="home_top">
    <div class="home_header">
      <div class="home_header_img">
        <img :src="userprofile.avatar_url">
      </div>
      <div class="home_header_title">
        <div class="header_name">{{ userprofile.nickname }}</div>
        <div class="header_grade">
          <user-label :label="genderLabel" :gender="userprofile.gender" :age="userprofile.age"/>
        </div>
      </div>
    </div>
    <div class="more" @click="changeProfile">
      <i class="fa fa-angle-right"></i>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import userLabel from './userLabel.vue'

export default {
  name: 'top-banner',
  props: [],
  data () {
    return {
    }
  },
  components: {
    userLabel
  },
  computed: {
    ...mapGetters([
      'userprofile'
    ]),
    genderLabel () {
      return this.userprofile.gender === 1 ? '潮爸' : (this.userprofile.gender === 2 ? '辣妈' : '未知')
    }
  },
  methods: {
  },
  mounted () {
  },
  created () {
  },
  methods: {
    changeProfile () {
      this.$router.push('/user/profile/edit')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import "@/assets/css/mixin.scss";

  .home_top {
    width: 100%;
    height: rem(280);
    background: url(../../../assets/images/profile_banner.jpg) no-repeat;
    background-size: cover;
    padding: rem(20) rem(20) 0;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .home_header {
      font-size: rem(26);
      color: #fff;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .home_header_img {
        width: rem(120);
        height: rem(120);
        border-radius: 100%;
        border: rem(3) #fff solid;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
      .home_header_title {
        margin-left: rem(15);
        .header_name {
          font-weight: bold;
          font-size: rem(26);
          margin-bottom: rem(8);
        }
      }
    }
    .more {
      font-size: rem(60);
      color: #fff;
    }
  }
</style>
